import {
  Navigation,
  NavigationWithLeftArrow,
  NavigationWithRightArrow,
  usePageLayoutStore,
} from '@diana/core';
import { useCallback, useState } from 'react';
import { StyledIconButton } from '../../FlowBuilder2Page.styles';

export const LeftDrawerToggleButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const setIsLeftDrawerOpen = usePageLayoutStore((store) => store.setIsLeftDrawerOpen);
  const isLeftDrawerOpen = usePageLayoutStore((store) => store.isLeftDrawerOpen);

  const onDrawerToggle = useCallback(
    () => setIsLeftDrawerOpen(!isLeftDrawerOpen),
    [isLeftDrawerOpen, setIsLeftDrawerOpen],
  );

  return (
    <StyledIconButton
      size="small"
      onClick={onDrawerToggle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered ? (
        isLeftDrawerOpen ? (
          <NavigationWithLeftArrow fontSize="small" />
        ) : (
          <NavigationWithRightArrow fontSize="small" />
        )
      ) : (
        <Navigation fontSize="small" />
      )}
    </StyledIconButton>
  );
};
